// extracted by mini-css-extract-plugin
export default {"root":"Speech_root__UsT9C","icon":"Speech_icon__gktZS"};